<template>
  <div>
  <meta name="viewport" content="width=device-width,initial-scale=1.0">
    <div class="bmdiv mat tc6">
      <div class="tdiv bgw pb20">
        <div class="fs30 nm bg-red twhite fbold tcenter">宁波第三技工学校报名登录</div>
        <div class="txt pl35 pr35" v-if="flow==1 || flow==2 || flow==4 || flow==7">
          <div class="fs15 mb25">
            <div class="mt20 mb5">尊敬的家长朋友、同学们：<router-link to="/sign-search" style="color: blue">信息补充/查询入口</router-link></div>
            <div class="tdent lh17">宁波第三技工学校2021年秋季入学招生工作已开始，现开设线上招生报名登记，请认真填写下表：</div>
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">1.毕业层次<font color="red">（*）</font></label>
            <select class="dblock input border-dd bg-f4 br2 wd100" name="" v-model="info.level">
              <option value="0">请选择</option>
              <option value="1">初中</option>
              <option value="2">高中</option>
            </select>
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">2.学生姓名<font color="red">（*）</font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="请填写学生姓名（必填）" v-model="info.name">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">3.学生性别</label>
            <select class="dblock input border-dd bg-f4 br2 wd100" name="" v-model="info.sex">
              <option value="1">男</option>
              <option value="2">女</option>
            </select>
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">4.学生身份证号码<font color="red">（*）</font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="请填写你的身份证号码（必填）" v-model="info.id_card" @blur="getCardInfo">
          </div>

          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">5.学生毕业学校（初中/高中）</label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="请填写你毕业学校的名称" v-model="info.graduate_school">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">6.毕业班级</label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="请填写你毕业班级" v-model="info.graduate_class">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">7.学生电话<font color="red">（*）</font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="请填写你的手机号码（必填）" v-model="info.phone">
          </div>
<!--          <div class="inputdiv" v-if="false">-->
<!--            <label for="" class="dblock fs16 mb5">7.民族</label>-->
<!--            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="请填写你的民族" v-model="info.nation">-->
<!--          </div>-->
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">8.学生户籍所在地</label>
            <div class="dflex between">
              <select class="input border-dd bg-f4 br2 mr15" name="" v-model="info.household_register_province" @change="()=>{info.household_register_city = '';this.getHouseholdCity();}">
                <option value="">省份</option>
                <option v-for="(item,index) in data_household_register_province" :value="index">{{item}}</option>
              </select>
              <select class="input border-dd bg-f4 br2" name="" v-model="info.household_register_city">
                <option value="">城市</option>
                <option v-for="(item,index) in data_household_register_city" :value="index">{{item}}</option>
              </select>
            </div>
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">9.学生现住址</label>
            <div class="dflex between">
              <select style="max-width: 35%;" class="input border-dd bg-f4 br2 mr10" name="" v-model="info.residential_address_province" @change="()=>{info.residential_address_city=info.residential_address_area='';this.getResidentialArea();this.getResidentialCity();}">
                <option value="">省份</option>
                <option v-for="(item,index) in data_residential_address_province" :value="index">{{item}}</option>
              </select>
              <select style="max-width: 30%;" class="input border-dd bg-f4 br2 mr10" name="" v-model="info.residential_address_city" @change="()=>{info.residential_address_area='';this.getResidentialArea();}">
                <option value="">城市</option>
                <option v-for="(item,index) in data_residential_address_city" :value="index">{{item}}</option>
              </select>
              <select  style="max-width: 25%;"class="input border-dd bg-f4 br2" name="" v-model="info.residential_address_area">
                <option value="">区/县</option>
                <option v-for="(item,index) in data_residential_address_area" :value="index">{{item}}</option>
              </select>
            </div>
            <input class="dblock input border-dd bg-f4 br2 wd100" style="margin-top: 10px" name="" placeholder="街道信息" v-model="info.residential_address_street">
          </div>
<!--          <div class="inputdiv" v-if="false">-->
<!--            <label for="" class="dblock fs16 mb5">10.学生家长姓名</label>-->
<!--            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="请填写家长姓名" v-model="info.parent_name">-->
<!--          </div>-->
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">10.学生家长联系电话</label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="请填写家长手机号码" v-model="info.parent_phone">
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">11.推荐老师姓名<font color="red"></font></label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="无老师推荐则填写:0（必填）" v-model="info.recommend_teacher">
          </div>
<!--          <div class="inputdiv" v-if="false">-->
<!--            <label for="" class="dblock fs16 mb5">13.推荐老师联系电话<font color="red">（*）</font></label>-->
<!--            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="无则填写:1-7（必填）	" v-model="info.recommend_teacher_phone">-->
<!--          </div>-->
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">12.第一志愿<font color="red">（*）</font></label>
            <select class="dblock input border-dd bg-f4 br2 wd100" name="" v-model="info.first_choice">
              <option value="">选择专业</option>
              <template v-for="(item,index) in data_department">
                <optgroup :label="getPName(index)" v-if="item.length!=0">
                  <option v-for="(item_,index_) in item" :value="index_">{{item_}}</option>
                </optgroup>
              </template>

            </select>
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">13.第二志愿</label>
            <select class="dblock input border-dd bg-f4 br2 wd100" name="" v-model="info.second_choice">
              <option value="">选择专业</option>
              <template v-for="(item,index) in data_department">
                <optgroup :label="getPName(index)" v-if="item.length!=0">
                  <option v-for="(item_,index_) in item" :value="index_">{{item_}}</option>
                </optgroup>
              </template>

            </select>
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">14.第三志愿</label>
            <select class="dblock input border-dd bg-f4 br2 wd100" name="" v-model="info.third_choice">
              <option value="">选择专业</option>
              <template v-for="(item,index) in data_department">
                <optgroup :label="getPName(index)" v-if="item.length!=0">
                  <option v-for="(item_,index_) in item" :value="index_">{{item_}}</option>
                </optgroup>
              </template>

            </select>
          </div>
          <div class="inputdiv">
            <label for="" class="dblock fs16 mb5">15.其他信息</label>
            <input class="dblock input border-dd bg-f4 br2 wd100" name="" placeholder="备注" v-model="info.remark">
          </div>
          <div class="btndiv tcenter">
            <a v-if="info.pay_status == 1" href="javascript:;" class="zbtn bg-red twhite fs15 br2">支付完成</a>
            <a v-else-if="flow==1 " href="javascript:;" class="zbtn bg-red twhite fs15 br2" @click="subInfo">提交</a>
            <a v-else-if="flow==2" href="javascript:;" class="zbtn bg-red twhite fs15 br2">调取支付中……</a>
            <a v-else-if="flow==4" href="javascript:;" class="zbtn bg-red twhite fs15 br2" @click="flow=3">继续操作</a>
            <a v-else-if="flow==7" href="javascript:;" class="zbtn bg-red twhite fs15 br2">已报名</a>
          </div>
        </div>
        <div class="message" v-else-if="flow == 3">
          <div class="msg1">您成功报名了<span>{{(info.first_choice)}},{{(info.second_choice)}},{{(info.third_choice)}}</span>专业</div>
          <div class="msg2">请您在<span>{{info.expired_date}}以前</span>完成支付，否则报名会自动取消</div>
          <div class="msg_img"><img :src="payImg"/></div>
          <div class="msg3">待支付款项：<span>{{info.pay_money}}</span>元</div>
        </div>
        <div class="success" v-else-if="flow == 5">
          <div class="suc1">
            <img src="../assets/images/success.jpg"/>
          </div>
          <div class="suc2">支付成功</div>
          <div class="suc3">你已完成支付</div>
          <div class="suc4"><router-link to="/">返回首页</router-link></div>
        </div>
        <div class="success" v-else-if="flow == 6">
          <div class="suc1">
            <img src="../assets/images/success.jpg"/>
          </div>
          <div class="suc2">报名成功</div>
          <div class="suc3">你已完成报名</div>
          <div class="suc4"><router-link to="/" v-if="info.before_test == 1">返回首页</router-link><router-link :to="'/sign-search?cid='+info.id_card" v-else>补充信息</router-link></div>
        </div>
      </div>
      <div class="bdiv bgw mt10 fs15 tc9 tcenter pt10 pb10">
        <div class="fbold">宁波第三技工学校</div>
        <div>Copyright&nbsp;&copy;&nbsp;2021 宁波第三技工学校</div>
      </div>
<!--        <img :src="payImg" style="width: 200px;height: 200px;display: block;position:fixed;top:50%;left: 50%;margin-top: -100px;margin-left: -100px;"/>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "sign",
  data(){
    return {
      info:{
        name:'',
        sex:1,
        graduate_school:'',
        graduate_class:'',
        phone:'',
        nation:'',//民族
        id_card:'',//身份证
        household_register_province:'',//户籍所在省
        household_register_city:'',//户籍所在市
        household_whole:'',//完整户籍
        residential_address_province:'',//居住省
        residential_address_city:'',//居住市
        residential_address_area:'',//居住区
        residential_address_street:'',//居住街道
        residential_address_whole:'',//居住完整地址
        parent_name:'',//家长名称
        parent_phone:'',//家长电话
        recommend_teacher:'',//推荐老师
        recommend_teacher_phone:'',//推荐老师电话
        first_choice:'',//第一志愿
        second_choice:'',//第二志愿
        third_choice:'',//第三志愿
        remark:'',//备注
        level:0,
        order_no:'',
        pay_money:0,
        pay_status:0,
        before_test:1,
      },
      data_level:[1,2],
      data_department_all:{},
      data_department:[],//专业数据
      data_household_register_province:[],//户籍所在省
      data_household_register_city:[],//户籍所在市
      data_residential_address_province:[],//居住省
      data_residential_address_city:[],//居住市
      data_residential_address_area:[],//居住区
      flow:1,
      payImg:'',
    }
  },
  created() {
    location.href='http://zh.nbdsjgxx.com/enroll/dist';
    this.getProvince();
    this.getDepartment();
  },
  mounted: function() {
    document.getElementsByTagName("body")[0].className="bm_body";
  },
  methods:{
    getPName(name){
      var arr = {
        biopharmaceutics:'生物制药系',
        digitalEconomy:'数字经济系',
        intelligentManufacturing:'智能制造系',
        modernService:'现代服务系',
      }
      return arr[name];
    },
    closePay(){
      this.flow = 4;
    },
    getCardInfo(){
      var getParam = {}
      getParam['id_card'] = this.info.id_card
      this.$request.get('enroll-detail',getParam,(response)=>{
        if(response.data.code == 200){
          this.flow = 7;
          this.info = response.data.data
          this.getResidentialArea();
          this.getHouseholdCity();
          this.getResidentialCity();
        }else{
          this.flow = 1;
        }
      })
    },
    subPay(){
      //调取支付接口
      var getParam = {}
      getParam['order_no'] = this.info.order_no
      this.$request.post('enroll-pay',getParam,(response)=>{
        if(response.data.code == 200){
          this.payImg = response.data.data
          this.flow = 3
          //开启定时任务 查看订单状态
          clearInterval(timer);
          var timer = setInterval(()=>{
            var getParam1 = {}
            getParam1['order_no'] = this.info.order_no
            this.$request.get('pay-detail',getParam1,(response)=>{
              if(response.data.code == 200){
                if(response.data.data.pay_status == 1){
                  clearInterval(timer);
                  this.flow = 5
                }
                if(response.data.data.expired == 1){
                  clearInterval(timer);
                  this.flow = 1
                  alert('支付已过期')
                }
              }
            });
          },3000);
        }else{
          alert('服务器错误，请重试');
          this.flow = 1;
        }
      },(response)=>{
        console.log(response)
        alert('服务器错误，请重试');
        this.flow = 1;
      })
    },
    subInfo(){
      if(!confirm("提交成功后将不可修改，是否继续？")){
        return;
      }
      if(this.info.phone == ''){
        alert('请填写学生手机号');
        return;
      }
      if(this.info.name == ''){
        alert('请填写学生姓名');
        return;
      }
      if(this.info.level == 0){
        alert('请选择学历');
        return;
      }
      if(this.info.id_card == ''){
        alert('身份证不能为空');
        return;
      }
      // else if(this.info.recommend_teacher == ''){
      //   alert('推荐老师姓名不能为空');
      //   return;
      // }
      // else if(this.info.recommend_teacher_phone == ''){
      //   alert('推荐老师联系电话不能为空');
      //   return;
      // }
      var household_whole = "";
      household_whole += this.info.household_register_province>0?this.data_household_register_province[this.info.household_register_province]:'';
      household_whole += this.info.household_register_city>0?this.data_household_register_city[this.info.household_register_city]:'';
      this.info.household_whole = household_whole;
      var residential_address_whole = '';
      residential_address_whole += this.info.residential_address_province>0?this.data_residential_address_province[this.info.residential_address_province]:'';
      residential_address_whole += this.info.residential_address_city>0?this.data_residential_address_city[this.info.residential_address_city]:'';
      residential_address_whole += this.info.residential_address_area>0?this.data_residential_address_area[this.info.residential_address_area]:'';
      residential_address_whole += this.info.residential_address_street;
      this.$request.post('enroll',this.info,response => {
        console.log(response);
        if(response.data.code == 200){
          this.info.order_no = response.data.data.order_no;
          this.info.pay_money = response.data.data.pay_money;
          this.info.pay_status = response.data.data.pay_status;
          this.info.expired_date = response.data.data.expired_date;
          this.info.before_test = response.data.data.before_test;
          //调取支付接口
          // this.flow = 2;
          // this.subPay();
          this.flow = 6;
        }else{
          alert(response.data.message);
        }
      })
    },
    getDepartment(){//获取专业
      this.$request.get('enroll-all-majors',[],response => {
        if(response.data.code == 200){
          this.data_department_all = response.data.data;
        }else{
          alert(response.data.message);
        }
      })
    },
    getProvince(){
      this.getAddress(0,response => {
        if(response.data.code == 200){
          this.data_household_register_province = response.data.data;
          this.data_residential_address_province = response.data.data;
        }else{
          alert(response.data.message);
        }
      })
    },
    getHouseholdCity(){//户籍城市
      this.getAddress(this.info.household_register_province,response => {
        if(response.data.code == 200){
          this.data_household_register_city = response.data.data;
        }else{
          alert(response.data.message);
        }

      })
    },
    getResidentialCity(){//居住城市
      this.getAddress(this.info.residential_address_province,response => {
        if(response.data.code == 200){
          this.data_residential_address_city = response.data.data;
        }else{
          alert(response.data.message);
        }
      })
    },
    getResidentialArea(){//居住区
      this.getAddress(this.info.residential_address_city,response => {
        if(response.data.code == 200){
          this.data_residential_address_area = response.data.data;
        }else{
          alert(response.data.message);
        }
      })
    },
    getAddress(pid,success){
      var getParam = {}
      getParam['parent_id'] = pid
      this.$request.get('get-region',getParam,success)
    }
  },
  watch:{
    info:{
      deep:true,
      handler:function (n,o) {
        if(n.level == 1){
          this.data_department = this.data_department_all.junior;
        }
        else if(n.level == 2){
          this.data_department = this.data_department_all.high;
        }
      }
    }
  }
}
</script>

<style scoped>
  .bmdiv{width: 95%;max-width: 430px;}
  .bmdiv .nm{height: 100px;line-height: 100px;font-size: 200%;}
  .bmdiv .inputdiv{margin-bottom: 20px;}
  .bmdiv input,.bmdiv select{line-height: 32px;height: 32px;}
  .bmdiv .wd100{width: 100%;}
  .bmdiv .txt{padding: 0 6%;}
  .bmdiv .tdent{text-align: justify;}
  .bmdiv .between{justify-content: space-between;}
  .bmdiv .input:focus{background-color: #fff;border: 1px solid /* #94070a */ #364797;box-shadow: 0 0 8px /* #94070a */ #364797;}
  .bmdiv textarea{width: 570px;height: 300px;resize: vertical;}
  .bmdiv .zbtn{padding: 7px 45px;width: 80%;}
  .message{height: 600px;}
  .message .msg1{font-size: 20px;padding-left: 20px;padding-right: 20px;margin-top: 110px;text-align: center;}
  .message .msg1 span{font-size: 24px;color: #000;}
  .message .msg2{font-size: 14px;padding-left: 50px;padding-right: 50px;margin-top: 90px;}
  .message .msg2 span{color: red;}
  .message .msg_img{margin-top: 40px;width: 100%}
  .message .msg_img img{width: 200px;height: 200px;display: block;margin: 0 auto;}
  .message .msg3{text-align: center;margin-top: 40px;font-size: 20px;}
  .message .msg3 span{color:red;}
  .success {text-align: center;}
  .suc1{margin-top: 170px;}
  .suc2{font-size: 26px;color: #000;font-weight: bold;margin-top: 20px;}
  .suc3{line-height: 24px;}
  .suc4{margin-top: 60px;}
  .suc4 a{margin:0 auto;display:block;line-height:48px;background: #fff;border: 2px solid #979797;color: #2b2b2b;width: 154px;height: 52px;border-radius: 8px;font-size: 18px;margin-bottom: 150px;}
</style>
<style>
.bm_body{min-width: auto;background: #f2f2f2;}
</style>



// WEBPACK FOOTER //
// src/pages/sign.vue